<template>
  <div class="w w1200">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家入驻申请</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="20">
      <el-col :span="6">
        <div class="aside">
          <h4 class="aside-title">商家入驻指南</h4>
          <ul class="aside-list">
            <li class="aside-item">签订入驻协议</li>
            <li class="aside-item">填写商家资料</li>
            <li class="aside-item">平台审核</li>
            <li class="aside-item">合同签订及缴费</li>
            <li class="aside-item active">店铺开通</li>
          </ul>
        </div>
        <div class="aside">
          <h4 class="aside-title">平台联系方式</h4>
          <ul class="aside-list">
            <li class="aside-item">电话：400-0456880</li>
            <li class="aside-item">邮箱：18748424242@163.com</li>
          </ul>
        </div>
      </el-col>
      <el-col :span="18" class="rightaside">
        <el-card shadow="never">
          <div class="card-header">
            <i class="el-icon-circle-check"></i>
            <span class="text">您的店铺已开通！</span>
            <el-button type="primary" size="mini" icon="el-icon-switch-button"
                       style="float: right" @click="$router.push('/settleIn/storeClose')">申请关店</el-button>
          </div>
        </el-card>
        <el-form :model="storeData" class="form" label-width="120px">
        <el-card class="mt-10" shadow="never" header="公司信息">
          <div class="content">
            <el-form-item label="公司名称">{{storeData.companyName}}</el-form-item>
            <el-form-item label="公司地址">{{storeData.companyLocationName}}{{storeData.address}}</el-form-item>
            <el-form-item label="公司电话">{{storeData.phone}}</el-form-item>
            <el-form-item label="联系人">{{storeData.contactPerson}}</el-form-item>
            <el-form-item label="联系人电话">{{storeData.emergencyManCall | phoneEncryption}}</el-form-item>
            <el-form-item label="联系人邮箱">{{storeData.emergencyManEmail}}</el-form-item>
            <el-form-item label="推荐人电话" v-if="storeData.recommendUserPhone">{{storeData.recommendUserPhone | phoneEncryption}}</el-form-item>
            <el-form-item label="纳税人识别号">{{storeData.taxpayerNumber}}</el-form-item>
            <el-form-item label="发票抬头">{{storeData.invoice}}</el-form-item>
            <el-form-item label="营业执照">
              <el-image class="image" :src="storeData.businessLicense" :preview-src-list="[storeData.businessLicense]" fit="contain"></el-image>
            </el-form-item>
            <el-form-item label="合作入驻协议">
              <el-link type="primary" @click="showAgreement">点击查看</el-link>
            </el-form-item>
          </div>
        </el-card>
        <el-card class="mt-10" shadow="never" header="店铺信息">
          <div class="content">
            <el-form-item label="店铺LOGO">
              <el-image class="image" :src="storeData.logo" fit="contain"></el-image>
            </el-form-item>
            <el-form-item label="店铺名称">{{storeData.name}}</el-form-item>
            <el-form-item label="店铺等级">{{totalData.levelName}}</el-form-item>
            <el-form-item label="店铺分类">{{totalData.merchantSortName}}</el-form-item>
            <el-form-item label="经营类目">{{totalData.types}}</el-form-item>
          </div>
        </el-card>
        </el-form>
      </el-col>
    </el-row>

    <el-dialog
      title="合作入驻协议"
      :visible.sync="dialogVisible"
      width="55%"
      :before-close="handleClose">
      <div v-html="agreementContents">这是一段信息</div>
    </el-dialog>
  </div>
</template>
<script>
import {agreementContent} from "@/api/xunyou";
export default {
  data() {
    return {
      dialogVisible: false,
      agreementContents: ''
    };
  },
  computed: {
    totalData () {
      return this.$store.state.applyStoreData;
    },
    storeData () {
      return this.$store.state.applyStoreData ? this.$store.state.applyStoreData.merchant : '';
    }
  },
  created() {
    this.getAgreementContent()
  },
  methods: {
    handleClose (done) {
      done();
    },
    showAgreement () {
      this.dialogVisible = true;
    },
    // 获取协议内容
    getAgreementContent() {
      agreementContent().then((res) => {
        if (res.code == 0) {
          this.agreementContents = res.rows[0].work;
        }
      }).catch((err) => {
        this.$message.error("查询协议内容失败，请稍后再试！");
      });
    }
  }
};
</script>

<style scoped lang="less">
.breakcrumbHeader {
  margin: 15px 0;
}
.aside {
  box-sizing: border-box;
  font-size: 14px;
  margin-right: 10px;
  margin-bottom: 40px;
  background-color: #fff;

  .aside-title {
    padding: 10px;
    border-bottom: 1px solid #ddd;
    font-size: 16px;
    font-weight: 700;
  }

  .aside-item {
    padding: 10px;

    &.active {
      color: var(--main-theme-color);
    }
  }
}
.mt-10{
  margin-top: 10px;
}
.image{
  width: 120px;
  height: 120px;
}
/deep/ .el-form-item{
  margin-bottom: 0;
}
/deep/ .el-card__header{
  padding: 10px 20px;
  font-size: 18px;
  font-weight: 500;
}
.card-header{
  font-size: 18px;
  color: #47d786;
  font-weight: 500;
  .el-icon-circle-check{
    font-size: 1.5em;
    vertical-align: middle;
  }
  .text{
    vertical-align: middle;
  }
}
</style>







// WEBPACK FOOTER //
// src/views/merchantSettled/storeOpen.vue